// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";

import { WACAvatarProps, WACAvatar } from "./avatar";

export interface UserDetailsCardProps extends WACAvatarProps {
    email: string;
}

export const UserDetailsCard = ({
    email,
    name,
    size,
    src
}: UserDetailsCardProps) => {
    return (
        <div css={userDetailsContainer}>
            <WACAvatar name={name} src={src} size={size} />
            <div css={userInfoContainer}>
                <div css={userNameLabel}>{name} </div>
                <div css={userEmailLabel}>{email} </div>
            </div>
        </div>
    );
};

const userDetailsContainer = css`
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: ${token("space.100")} ${token("space.200")};
    width: 250px;
    background-color: #172b4d;
`;

const userInfoContainer = css`
    display: flex;
    flex-flow: column;
    margin-left: ${token("space.100")};
`;

const userNameLabel = css`
    font-size: ${token("space.200")};
    line-height: ${token("space.250")};
    color: #ffffff;
`;

const userEmailLabel = css`
    font-size: ${token("space.150")};
    line-height: ${token("space.150")};
    color: #c1c7d0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
